import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import DigestPreviewPage from "@/pages/admin/DigestPreviewPage";

export const Route = createFileRoute("/_admin/admin/digest-preview")({
  head: () => pageHead("Admin · Digest Preview", "AKIVA admin · digest preview portal.", "/admin/digest-preview", true),
  component: DigestPreviewPage,
});
